export default (that = {}) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  // {
  //   field: 'checkbox',
  //   width: 40,
  //   align: 'center',
  //   fixed: 'left',
  //   type: 'checkbox',
  // },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 170,
    slots: {
      default: 'opt',
    },
  },
  {
    title: that.$l('table_label_proofing_no') || '单据编号',
    field: 'proofingNo',
    width: 180,
    align: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    fixed: 'left',
  },
  {
    title: that.$l('table_label_request_date') || '开发依赖日期',
    field: 'requestDate',
    width: 130,
    align: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    title: that.$l('table_label_finish_date') || '要求完成日期',
    field: 'finishDate',
    width: 120,
    align: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    title: that.$l('table_label_salesperson_name') || '业务员姓名',
    field: 'salesPersonName',
    width: 130,
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    title: that.$l('table_label_designer_name') || '设计人员姓名',
    field: 'designerName',
    width: 120,
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    title: that.$l('table_label_sales_season') || '销售季节',
    field: 'sampleSalesSeason',
    width: 140,
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    title: that.$l('table_label_proofing_purpose') || '打样用途',
    field: 'proofingUse',
    minWidth: 200,
    align: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    title: that.$l('table_label_customer') || '客户',
    field: 'cusName',
    width: 140,
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    title: that.$l('table_label_customer_contact') || '客户联系人',
    field: 'cusContacts',
    width: 120,
    align: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    title: that.$l('table_label_customer_contact_number') || '客户联系人电话',
    field: 'cusContactsPhone',
    width: 130,
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    title: that.$l('table_label_customer_sample_number') || '客户样品款号',
    field: 'cusSampleNo',
    minWidth: 200,
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    title: that.$l('table_label_proofing_factory') || '打样工厂',
    field: 'scmName',
    width: 140,
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    title: that.$l('table_label_factory_contact') || '工厂联系人',
    field: 'scmContacts',
    width: 120,
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    title: that.$l('table_label_factory_contact_number') || '工厂联系人电话',
    field: 'scmContactsPhone',
    width: 130,
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    title: that.$l('table_label_process_desc') || '工艺说明',
    field: 'bookTechDescription',
    minWidth: 200,
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    title: that.$l('table_label_development_desc') || '开发说明',
    field: 'developDescription',
    minWidth: 200,
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    title: that.$l('table_label_price') || '单价',
    field: 'unitPrice',
    width: 110,
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    title: that.$l('table_label_proofing_quantity') || '打样数量',
    field: 'proofingQty',
    width: 110,
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    title: that.$l('table_label_sample_cost') || '样品费用',
    field: 'proofingAmount',
    width: 110,
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    title: that.$l('table_label_additional_cost') || '附加费用',
    field: 'proofingFee',
    width: 110,
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    title: that.$l('table_label_total_amount') || '合计金额',
    field: 'totalAmount',
    width: 110,
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    title: that.$l('INDEX.Status') || '状态',
    width: 80,
    align: 'center',
    slots: { default: 'status' },
  },
  {
    field: 'createByName',
    title: that.$l('INDEX.table_label_creator') || '创建人',
    width: 100,
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    title: that.$l('INDEX.table_label_creator_date') || '创建时间',
    field: 'createDate',
    width: 170,
    align: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'modifyByName',
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    width: 100,
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    field: 'modifyDate',
    width: 170,
    align: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
]
